import Vue from 'vue'
import App from './App.vue'
import store from './store'
import router from './router'
import moment from 'moment';
import 'moment-timezone';
import './assets/js/iconfont';
import FastClick from 'fastclick';
import http from './lib/http';
import util from './lib/util';
import VueWechatTitle from 'vue-wechat-title';

Vue.use(VueWechatTitle)

FastClick.attach(document.body);

Vue.prototype.$moment = moment;
Vue.prototype.$http = http;
Vue.prototype.$util = util;
Vue.config.productionTip = false;

new Vue({
  store,
  router,
  render: h => h(App)
}).$mount('#app')
